// @flow

import dash_api from '../support/dash_api';
import { ReduxAsyncAction } from '../support/utils';
import NotificationActions from './NotificationActions';

import type {
  Mapping,
  ConversionValueMapping
} from '../types/skadnetworkTypes';

const SK_AD_NETWORK_PATH = '/v1/skadnetwork';

const GetConversionValueMapping = new ReduxAsyncAction(
  'GET_CONVERSION_VALUE_MAPPING'
);
GetConversionValueMapping.registerRequest(function() {
  return dash_api
    .get(`${SK_AD_NETWORK_PATH}/conversion-value-mapping`)
    .then(({ data }) => data);
});
export const GET_CONVERSION_VALUE_MAPPING = GetConversionValueMapping.constants;
export const getConversionValueMapping = GetConversionValueMapping.request;

export const UPDATE_CONVERSION_VALUE_MAPPING =
  'UPDATE_CONVERSION_VALUE_MAPPING';
export function updateConversionValueMapping(updateData: Mapping) {
  const conversionValueMappingUpdate = {
    conversionValue: updateData.conversionValue,
    type: 'update',
    conversionEvent: updateData.conversionEvent
  };
  return {
    type: UPDATE_CONVERSION_VALUE_MAPPING,
    data: conversionValueMappingUpdate
  };
}

export const DELETE_CONVERSION_VALUE_MAPPING =
  'DELETE_CONVERSION_VALUE_MAPPING';
export function deleteConversionValueMapping(conversionValue: number) {
  const conversionValueMappingDelete = {
    type: 'delete',
    conversionValue
  };
  return {
    type: DELETE_CONVERSION_VALUE_MAPPING,
    data: conversionValueMappingDelete
  };
}

export const UPDATE_SK_AD_NETWORK_ENABLED_EDIT =
  'UPDATE_SK_AD_NETWORK_ENABLED_EDIT';
export function updateSkAdNetworkEnabledEdit(skAdNetworkEnabledEdit: boolean) {
  return {
    type: UPDATE_SK_AD_NETWORK_ENABLED_EDIT,
    data: skAdNetworkEnabledEdit
  };
}

export const SaveSkAdNetworkConfiguration = new ReduxAsyncAction(
  'SAVE_SK_AD_NETWORK_CONFIGURATION'
);
SaveSkAdNetworkConfiguration.registerRequest(function(configuration: {
  conversionValueMapping: ConversionValueMapping,
  skAdNetworkEnabled: boolean
}) {
  return dash_api
    .put(SK_AD_NETWORK_PATH, configuration)
    .then(({ data }) => data);
});

export const SAVE_SK_AD_NETWORK_CONFIGURATION =
  SaveSkAdNetworkConfiguration.constants;
export const saveSkAdNetworkConfiguration = (configuration: {
  conversionValueMapping: ConversionValueMapping,
  skAdNetworkEnabled: boolean
}) => async (dispatch: (action: Object) => Object) => {
  try {
    await dispatch(SaveSkAdNetworkConfiguration.request(configuration));
  } catch (err) {
    err.data && NotificationActions.showNotification(err.data.message, 'error');
  }
};

export const CANCEL_SK_AD_NETWORK_CONFIGURATION_CHANGES =
  'CANCEL_SK_AD_NETWORK_CONFIGURATION_CHANGES';
export function cancelSkAdNetworkConfigurationChanges() {
  return {
    type: CANCEL_SK_AD_NETWORK_CONFIGURATION_CHANGES
  };
}
